<template>
  <div class="p-5 w-full h-full overflow-scroll scrolling-touch">
    <MDArea class="lg:max-w-2xl" :md="require('raw-loader!../MDs/welcome.md').default">
    </MDArea>

    <!-- <O3DEditor>
    </O3DEditor> -->

    <div class="flex lg:max-w-4xl">
      <PhoneArea :maxWidth="414" class="full mx-2">
        <ThankYouCanvas>
          <ThankYouLayoutGlass></ThankYouLayoutGlass>
        </ThankYouCanvas>
      </PhoneArea>
      <PhoneArea :maxWidth="414" class="full mx-2">
        <EnergyFlame>
        </EnergyFlame>
      </PhoneArea>
    </div>

    <div class="h-64"></div>

    <!--
      <div class="democanvas">
        <ThankYouCanvas></ThankYouCanvas>
      </div>
    -->
    <!--
      <div class="democanvas">
      </div>
    -->

    <!--
    <O3D>
      <Comment>
        This is a house.
      </Comment>
      <O3D :py="20">
        <Comment>
          This is roof.
        </Comment>
        <Plane></Plane>
      </O3D>
      <O3D>
        <Comment>
          This  is roof.
        </Comment>
        <Plane></Plane>
      </O3D>
      <O3D>
        <Comment>
          This is Chimney
        </Comment>
        <Cylinder></Cylinder>
      </O3D>
      <O3D>
        <Comment>
          Plane is wall.
        </Comment>
        <Plane></Plane>
      </O3D>
      <O3D>
        <Comment>
          Plane is floor.
        </Comment>
        <Plane></Plane>
      </O3D>
    </O3D>
    -->


  </div>
</template>

<script>
export default {
  mixins: [
    require('../../Reusable/O3DCompos').O3DCompos
  ],
  mounted () {
    window.dispatchEvent(new Event('resize'))
  }
}
</script>

<style>
.democanvas{
  width: 100%;
  max-width: 480px;
  height: 480px;
}
</style>
